export default __webpack_public_path__ + "static/media/dolla.07c27d2f.png";